import React, { useState } from 'react';
import {
  Button,
  Menu,
  MenuItem,
  IconButton,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import usePlanGate from '../../hooks/usePlanGate';

const ResponsiveActions = ({
  toggleModal,
  handleModalOpen,
  onSchedule,
  isArchived,
}) => {
  const theme = useTheme();
  // New interviews need an active plan
  const scheduleGate = usePlanGate();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const actionButtons = (
    <>
      <Button
        size="small"
        variant="contained"
        onClick={toggleModal}
        sx={{
          backgroundColor: '#fff',
          color: theme.palette.text.main,
          border: '1px solid',
          borderColor: theme.palette.secondary.main,
          textTransform: 'none',
          whiteSpace: 'nowrap',
          boxShadow: 'none',
          '&.Mui-disabled': {
            backgroundColor: '#fff',
            color: '#9CA3AF',
            borderColor: '#D1D5DB',
            cursor: 'not-allowed',
          },
        }}
      >
        View Job Description
      </Button>

      <Button
        size="small"
        variant="contained"
        disabled={isArchived}
        {...scheduleGate.controlProps}
        onClick={scheduleGate.guard(onSchedule)}
        sx={{
          backgroundColor: theme.palette.info.main,
          color: theme.palette.text.light,
          textTransform: "none",
          whiteSpace: "nowrap",
          minWidth: "max-content",
          "&.Mui-disabled": {
            backgroundColor: theme.palette.secondary.v3,
            color: theme.palette.text.light,
          },
        }}
      >
        Schedule interview
      </Button>
      {scheduleGate.hint}

      <Button
        variant="contained"
        size="small"
        disabled={isArchived}
        onClick={handleModalOpen}
        sx={{
          backgroundColor: isArchived ? theme.palette.secondary.v2 : theme.palette.info.main,
          color: isArchived ? '#9CA3AF' : theme.palette.text.light,
          textTransform: 'none',
          '&.Mui-disabled': {
            backgroundColor: theme.palette.secondary.v3,
            color: theme.palette.text.light,
          },
        }}
        className={`inline-flex items-center justify-between rounded-lg whitespace-nowrap`}
      >
        <span>Edit</span>
      </Button>

    </>
  );

  return (
    <div className="flex gap-2 items-center">
      {!isMobile ? (
        actionButtons
      ) : (
        <>
          <IconButton sx={{ padding: 0 }} onClick={handleOpenMenu}>
            <MoreVertIcon />
          </IconButton>
          <Menu anchorEl={anchorEl} open={openMenu} onClose={handleCloseMenu}>
            <MenuItem
              onClick={() => {
                toggleModal();
                handleCloseMenu();
              }}
            >
              View Job Description
            </MenuItem>
            <MenuItem
              onClick={() => {
                scheduleGate.guard(onSchedule)();
                handleCloseMenu();
              }}
              disabled={isArchived}
            >
              Schedule interview
            </MenuItem>
            <MenuItem
              onClick={() => {
                handleModalOpen();
                handleCloseMenu();
              }}
              disabled={isArchived}
            >
              Edit
            </MenuItem>
          </Menu>
        </>
      )}
    </div>
  );
};

export default ResponsiveActions;
